import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadGoogleMapsApi } from './LoadGoogleMapsUtils';

const GoogleMapsContext = createContext<{ loaded: boolean }>({ loaded: false });

export const GoogleMapsProvider: React.FC<{ apiKey: string, children: React.ReactNode }> = ({ apiKey, children }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;
    loadGoogleMapsApi(apiKey, 'visualization,places').then(() => {
      if (isMounted) setLoaded(true);
    });
    return () => { isMounted = false; };
  }, [apiKey]);

  return (
    <GoogleMapsContext.Provider value={{ loaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
};

export const useGoogleMaps = () => useContext(GoogleMapsContext);